import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = '꿈현.Labs';
const SITE_URL = 'https://kkumhyeonlabs.com';
const DEFAULT_DESCRIPTION = '꿈현.Labs — 꿈을 현실로 만드는 방법을 연구';
const DEFAULT_IMAGE = `${SITE_URL}/icon.png`;

const Seo = ({
  title,
  description = DEFAULT_DESCRIPTION,
  canonicalPath,
  image = DEFAULT_IMAGE,
}) => {
  const canonical = useMemo(() => {
    if (canonicalPath) {
      return `${SITE_URL}${canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`}`;
    }

    if (typeof window !== 'undefined' && window?.location) {
      return `${SITE_URL}${window.location.pathname}${window.location.search || ''}`;
    }

    return SITE_URL;
  }, [canonicalPath]);

  const fullTitle = useMemo(() => {
    if (!title) return SITE_NAME;
    return title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
  }, [title]);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
